import {DNA} from "react-loader-spinner";
import React from "react";

const AxisSpinner = ({loading}) => {
    return (
        <div className={["spinner-wrapper"]}>
            <DNA
                visible={loading}
                height="80"
                width="80"
                ariaLabel="dna-loading"
                wrapperStyle={{}}
                wrapperClass="dna-wrapper"
            />
        </div>
    );
}

export default AxisSpinner;
